// frontend/src/components/OcrUploader.js
import React, { useState } from 'react';
import { Container, Box, Button, Typography, TextField } from '@mui/material';
import api from '../services/api'; // Import the api instance

const OcrUploader = ({ onDataExtracted }) => {
  const [selectedFile, setSelectedFile] = useState(null);
  const [error, setError] = useState('');

  const handleFileChange = (e) => {
    setSelectedFile(e.target.files[0]);
  };

  const handleUpload = () => {
    if (!selectedFile) {
      setError('Please select a file');
      return;
    }
    setError('');
    const formData = new FormData();
    formData.append('ocrFile', selectedFile);
    api.post('/complaints/ocr', formData, {
      headers: { 'Content-Type': 'multipart/form-data' }
    })
    .then(res => {
      // Pass the extracted data back to parent component
      onDataExtracted(res.data);
    })
    .catch(err => {
      setError('OCR failed: ' + (err.response?.data?.error || err.message));
    });
  };

  return (
    <Container maxWidth="sm">
      <Box sx={{ mt: 4 }}>
        <Typography variant="h5" gutterBottom>
          Upload Handwritten Complaint for OCR
        </Typography>
        <TextField
          type="file"
          onChange={handleFileChange}
          fullWidth
          InputLabelProps={{ shrink: true }}
        />
        {error && <Typography color="error">{error}</Typography>}
        <Button variant="contained" color="primary" onClick={handleUpload} sx={{ mt: 2 }}>
          Process OCR
        </Button>
      </Box>
    </Container>
  );
};

export default OcrUploader;
